module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxOCIgdmlld0JveD0iMCAwIDE4IDE4Ij4NCiAgPGRlZnM+DQogICAgPHN0eWxlPg0KICAgICAgLmNscy0xIHsNCiAgICAgICAgZmlsbDogIzFlODBmZjsNCiAgICAgICAgZmlsbC1ydWxlOiBldmVub2RkOw0KICAgICAgfQ0KICAgIDwvc3R5bGU+DQogIDwvZGVmcz4NCiAgPHBhdGggaWQ9IumrmOe6p+e8lui+kV/ok50iIGNsYXNzPSJjbHMtMSIgZD0iTTEyNjIuNSw3NTMuOVY3NjVoLTNWNzUzLjlIMTI1M1Y3NTFoMTZ2Mi45aC02LjVaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTI1MiAtNzQ5KSIvPg0KPC9zdmc+DQo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/questionnaire/seniorEditor1.svg
// module id = pOkq
// module chunks = 1